import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIDataProvider, TApiResponse, AdminApiPaths } from '../../api';

interface ITopicSortingItem {
  topicId: string;
  sortingOrder?: number;
}

export interface IAdminUpdateTopicSorting {
  topics: Array<ITopicSortingItem>;
}

const apiDataProvider = new APIDataProvider();

export const adminUpdateTopicSorting = createAsyncThunk(
  'admin/topics/updateTopicSorting',
  async (data: IAdminUpdateTopicSorting) => {
    const response = await apiDataProvider.post<
      TApiResponse<ITopicSortingItem[]>
    >(`${AdminApiPaths.topics}/updateSorting`, data);

    return response.data;
  }
);

export default adminUpdateTopicSorting;
